var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchOutlinedRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.969 15.1168L0.6863 19.3995L2.1005 20.8137L6.3832 16.531C7.9231 17.763 9.876 18.5 12 18.5C16.968 18.5 21 14.468 21 9.5C21 4.532 16.968 0.5 12 0.5C7.032 0.5 3 4.532 3 9.5C3 11.624 3.737 13.5769 4.969 15.1168ZM6.9753 14.3748C5.7525 13.1146 5 11.3956 5 9.5C5 5.6325 8.1325 2.5 12 2.5C15.8675 2.5 19 5.6325 19 9.5C19 13.3675 15.8675 16.5 12 16.5C10.1044 16.5 8.3854 15.7475 7.1252 14.5247L6.9753 14.3748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutlinedRight);
export default __webpack_public_path__ + "static/media/search-outlined-right.fd76cb9d9b3b9863fa303a364b1b593b.svg";
export { ForwardRef as ReactComponent };